
riot.tag2('raw', '', '', '', function(opts) {
this.on('update', function() {
  return this.root.innerHTML = opts.content;
});
});